export default "__VITE_ASSET__D07sI8HH__"